export default __webpack_public_path__ + "static/media/option-deponi.3b9639fa.svg";